const CHESSHOOD_BASE_URL = "https://chesshood.com";

const toAbsoluteUrl = (path) => `${CHESSHOOD_BASE_URL}${path}`;

export const WORLD_BUILDINGS = [
  {
    id: "chessAcademy",
    label: "Chess Academy",
    href: toAbsoluteUrl("/chessbasics"),
    menuLabel: "Chess Academy",
    entryRatios: {
      x: 0.265,
      y: 0.205,
    },
    boundsRatios: {
      xMin: 0.12,
      xMax: 0.39,
      yMin: 0.04,
      yMax: 0.23,
    },
  },
  {
    id: "battleArena",
    label: "Battle Arena",
    href: toAbsoluteUrl("/lichess"),
    menuLabel: "Battle Arena",
    entryRatios: {
      x: 0.765,
      y: 0.205,
    },
    boundsRatios: {
      xMin: 0.62,
      xMax: 0.92,
      yMin: 0.02,
      yMax: 0.20,
    },
  },
  {
    id: "trainingHall",
    label: "Training Hall",
    href: toAbsoluteUrl("/meetings"),
    menuLabel: "Training Hall",
    autoEnter: true,
    entryRatios: {
      x: 0.145,
      y: 0.395,
    },
    boundsRatios: {
      xMin: 0.05,
      xMax: 0.26,
      yMin: 0.27,
      yMax: 0.45,
    },
  },
  {
    id: "winchesterClub",
    label: "Winchester Club",
    href: toAbsoluteUrl("/chessclub"),
    menuLabel: "Winchester Club",
    autoEnter: true,
    entryRatios: {
      x: 0.49,
      y: 0.33,
    },
    boundsRatios: {
      xMin: 0.39,
      xMax: 0.62,
      yMin: 0.19,
      yMax: 0.35,
    },
  },
  {
    id: "puzzleRoom",
    label: "Puzzle Room",
    href: toAbsoluteUrl("/categories"),
    menuLabel: "Puzzle Room",
    autoEnter: true,
    entryRatios: {
      x: 0.81,
      y: 0.395,
    },
    boundsRatios: {
      xMin: 0.71,
      xMax: 0.92,
      yMin: 0.27,
      yMax: 0.45,
    },
  },
  {
    id: "theCove",
    label: "The Cove",
    href: toAbsoluteUrl("/calendar"),
    menuLabel: "The Cove",
    entryRatios: {
      x: 0.145,
      y: 0.705,
    },
    boundsRatios: {
      xMin: 0.02,
      xMax: 0.24,
      yMin: 0.60,
      yMax: 0.82,
    },
  },
  {
    id: "superMart",
    label: "Super Mart",
    href: toAbsoluteUrl("/AppDownloadSection"),
    menuLabel: "Super Mart",
    entryRatios: {
      x: 0.48,
      y: 0.795,
    },
    boundsRatios: {
      xMin: 0.35,
      xMax: 0.67,
      yMin: 0.67,
      yMax: 0.84,
    },
  },
  {
    id: "chesshoodHq",
    label: "Chesshood HQ",
    href: toAbsoluteUrl("/aboutus"),
    menuLabel: "Chesshood HQ",
    entryRatios: {
      x: 0.76,
      y: 0.69,
    },
    boundsRatios: {
      xMin: 0.62,
      xMax: 0.91,
      yMin: 0.58,
      yMax: 0.77,
    },
  },
  {
    id: "adventureGate",
    label: "Adventure Gate",
    href: toAbsoluteUrl("/chesscamp"),
    menuLabel: "Adventure",
    entryRatios: {
      x: 0.83,
      y: 0.82,
    },
    boundsRatios: {
      xMin: 0.68,
      xMax: 0.96,
      yMin: 0.72,
      yMax: 0.95,
    },
  },
];
